const en: { [key: string]: string } = {
  required: 'Field ${} is required',
  minLength: 'Field ${} is too short',
  numeric: 'Field ${} must be a number',
  email: 'Field ${} must be a valid email address',
  sameAsPassword: 'Passwords must be the same',
  mustBeTrue: 'Field ${} must be selected',
  not: 'Field ${} must be diffrent than old password',
  minValue: 'Field ${} must be greater than 0',
  decimal: 'Field ${} must be greater than 0',
  macAddress: 'Field ${} must be valid MAC address',
};
const pl: { [key: string]: string } = {
  required: 'Pole ${} jest wymagane',
  minLength: 'Pole ${} jest za krótkie',
  numeric: 'Pole ${} musi być liczbą',
  email: 'Pole ${} musi być poprawnym adresem email',
  sameAsPassword: 'Hasła muszą być identyczne',
  mustBeTrue: 'Pole ${} jest wymagane',
  not: 'Pole ${} musi być inne niż stare hasło',
  minValue: 'Pole ${} musi być większe niż 0',
  decimal: 'Pole ${} musi być większe niż 0',
  macAddress: 'Pole ${} musi być poprawnym adresem MAC',
};

export {en, pl};
